import React, { Component } from 'react';
import Tabs from './Tabs';
import { Link } from 'react-router-dom';

class LinkResults extends Component {

    render() {
        
        return (
           
            <div>
                Search RESULTS
                <br/>
                <br/>
                Results: {this.props.totalCount}
                <br/>
                Broken: {this.props.redCount}
                <Tabs>
                    <div label="ACTIVE">
                        {this.props.data_holder.filter(data => data.color === ('green')).map((results,index) => (
                        <div key={index}>
                        <Link to={'/ResultDetails/?url=' + results.url} style={{color: results.color}} >{results.url}</Link>
                        </div>
                        ))}
                    </div>
                    <div label="BROKEN" >
                        {this.props.data_holder.filter(data => data.color === ('red')).map((results,index) => (
                        <div key={index}>
                        <a href={'/ResultDetails/?url=' + results.url} style={{color: results.color}} >{results.url}</a>
                        </div>
                        ))}
                    </div>
                </Tabs>

            </div>
        )
    }
}


export default LinkResults


// WEBPACK FOOTER //
// ./src/components/layout/LinkResults.js